// extracted by mini-css-extract-plugin
export default {"sideNavOuterToolbar":"side-nav-outer-toolbar_sideNavOuterToolbar__sSgBy"};